import { getWeixinVersionInfo } from '../helper/common-helper';
import { callWxClientMethod } from '../helper/wx-client-helper';

import { formatMessage } from '../intl/helper';
import actionText3 from '../intl/messages/action/part3';
import { confirm } from '../component/mui/dialog/confirm-dialog';
import { isMiniProgramBrowser } from './map';

const wxInfo = getWeixinVersionInfo();

export const PERMISSION_DENIED = 1;
export const TIMEOUT = 3;
export const defaultLocateConfig = {
  timeout: 5000,
  maximumAge: 0,
  enableHighAccuracy: true,
};
export const commonError = {
  code: 4,
  message: formatMessage(actionText3.actionlocateFailed),
};

// 微信定位
export const weixinLocation = () =>
  new Promise((resolve, reject) => {
    // ios10中的微信定位不响应
    const iosTimer = setTimeout(() => {
      reject({
        code: TIMEOUT,
        message: formatMessage(actionText3.actionuserGetLocationTimeout),
      });
    }, 5000);

    callWxClientMethod('getLocation', {
      success: position => {
        clearTimeout(iosTimer);
        resolve(position);
      },
      error: () => {
        clearTimeout(iosTimer);
        reject(commonError);
      },
    });
  });

const getGeolocation = (resolve, reject, config) => {
  if (navigator.geolocation) {
    // iOS16.4 定位可能不响应
    const iosTimer = setTimeout(() => {
      reject({
        code: TIMEOUT,
        message: formatMessage(actionText3.actionuserGetLocationTimeout),
      });
    }, 6000);

    navigator.geolocation.getCurrentPosition(
      position => {
        clearTimeout(iosTimer);
        resolve(position.coords);
      },
      error => {
        clearTimeout(iosTimer);
        reject(error);
      },
      {
        ...defaultLocateConfig,
        ...config,
      },
    );
  } else {
    reject(commonError);
  }
};

// h5原生定位
export const getCurrentPosition = (config = {}) =>
  new Promise((resolve, reject) => {
    const alreadyGetUserAgree = window.sessionStorage.getItem('alreadyGetUserAgree');
    const isMiniProgram = isMiniProgramBrowser();
    if (alreadyGetUserAgree || !isMiniProgram) {
      getGeolocation(resolve, reject, config);
    } else if (isMiniProgram) {
      confirm({
        content: '',
        isBeforeMap: true,
        onConfirm: () => {
          window.sessionStorage.setItem('alreadyGetUserAgree', true);
          getGeolocation(resolve, reject, config);
        },
      });
    }
  }).catch(error => {
    // error 中的属性是 readonly 的，不能赋值
    const result = {
      code: error.code,
      message: error.message,
    };

    if (result.code === PERMISSION_DENIED) {
      result.message = formatMessage(actionText3.actionuserRefuseGetLocation);
      throw result;
    } else if (result.code === TIMEOUT) {
      result.message = formatMessage(actionText3.actionuserGetLocationTimeout);
      throw result;
    } else if (wxInfo.weixin) {
      // 尝试微信定位
      return weixinLocation();
    } else {
      throw result;
    }
  });


// export const getCurrentPosition = (config = {}) =>
//   new Promise((resolve, reject) => {
//     if (navigator.geolocation) {
//       navigator.geolocation.getCurrentPosition(
//         position => {
//           resolve(position.coords);
//         },
//         error => {
//           reject(error);
//         },
//         {
//           ...defaultLocateConfig,
//           ...config,
//         },
//       );
//     } else {
//       reject(commonError);
//     }
//   }).catch(error => {
//     // error 中的属性是 readonly 的，不能赋值
//     const result = {
//       code: error.code,
//       message: error.message,
//     };

//     if (result.code === PERMISSION_DENIED) {
//       result.message = formatMessage(actionText3.actionuserRefuseGetLocation);
//       throw result;
//     } else if (result.code === TIMEOUT) {
//       result.message = formatMessage(actionText3.actionuserGetLocationTimeout);
//       throw result;
//     } else if (wxInfo.weixin) {
//       // 尝试微信定位
//       return weixinLocation();
//     } else {
//       throw result;
//     }
//   });

/**
 * 高德，百度，Google地图定位偏移
 * 一、在进行地图开发过程中，我们一般能接触到以下三种类型的地图坐标系：
 * 1.WGS－84原始坐标系，一般用国际GPS纪录仪记录下来的经纬度，通过GPS定位拿到的原始经纬度，Google和高德地图定位的的经纬度（国外）都是基于WGS－84坐标系的；但是在国内是不允许直接用WGS84坐标系标注的，必须经过加密后才能使用；
 * 2.GCJ－02坐标系，又名“火星坐标系”，是我国国测局独创的坐标体系，由WGS－84加密而成，在国内，必须至少使用GCJ－02坐标系，或者使用在GCJ－02加密后再进行加密的坐标系，如百度坐标系。高德和Google在国内都是使用GCJ－02坐标系，可以说，GCJ－02是国内最广泛使用的坐标系；
 * 3.百度坐标系:bd-09，百度坐标系是在GCJ－02坐标系的基础上再次加密偏移后形成的坐标系，只适用于百度地图。(目前百度API提供了从其它坐标系转换为百度坐标系的API，但却没有从百度坐标系转为其他坐标系的API)
 * 二、为什么会发生偏移？
 * 1.由于坐标系之间不兼容，如在百度地图上定位的经纬度拿到高德地图上直接描点就肯定会发生偏移；只考虑国内的情况，高德地图和Google地图是可以不经过转换也能够准确显示的（在国内用的都是GCJ－02坐标系）
 * 原文链接：https://blog.csdn.net/a13570320979/java/article/details/51366355
 */



// WEBPACK FOOTER //
// ./src/helper/location.js